// Mock data for Janes Electrical Services website

export const companyInfo = {
  name: "Janes Electrical Services Inc",
  tagline: "Reliable Electrical Solutions You Can Trust",
  email: "janeselectricalservices@gmail.com",
  phone: "+14168396011",
  location: "Guelph, Ontario, Canada",
  description: "Janes Electrical Services Inc is a locally owned and operated electrical contracting company providing reliable, high-quality electrical services for residential, commercial and small industrial customers. We specialize in installations, repairs, upgrades, and troubleshooting, with a strong focus on safety, efficiency, and code compliance.\n\nFrom new construction and remodels to service calls and emergency repairs, we take pride in delivering dependable workmanship and clear communication on every job. Our goal is simple: to provide honest service, fair pricing, and electrical solutions our customers can trust."
};

export const services = [
  {
    id: 1,
    title: "Residential",
    icon: "Home",
    image: "https://images.unsplash.com/photo-1759150712360-6d48015e4f86?w=800&q=80",
    keywords: ["pot lights", "residential electrician", "home electrical", "lighting installation", "outlet repair"]
  },
  {
    id: 2,
    title: "Commercial",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1758193017781-e3aee6c3e359?w=800&q=80",
    keywords: ["commercial electrician", "business electrical", "office wiring", "retail lighting"]
  },
  {
    id: 3,
    title: "Industrial",
    icon: "Factory",
    image: "https://images.unsplash.com/photo-1768128834406-f5b1b962af9d?w=800&q=80",
    keywords: ["industrial electrician", "factory electrical", "manufacturing electrical", "industrial wiring"]
  }
];

export const evChargerFeature = {
  title: "EV Charger Installation",
  subtitle: "Power Your Electric Vehicle at Home",
  description: "Make the switch to electric easier with a professionally installed home EV charger. We handle everything from electrical panel upgrades to charger installation, ensuring your home is ready for the future of transportation.",
  features: [
    "Level 2 Charger Installation",
    "Electrical Panel Upgrades",
    "Permit & Inspection Handling",
    "All Major Brands Supported"
  ],
  image: "https://images.unsplash.com/photo-1631347826177-de288776ed3b?w=800&q=80",
  keywords: ["EV charger installation", "electric vehicle charger", "Level 2 charger", "home EV charging"]
};

export const serviceAreas = [
  "Guelph",
  "Toronto", 
  "Mississauga",
  "Kitchener",
  "Waterloo",
  "Cambridge",
  "Hamilton",
  "Surrounding Areas"
];

export const serviceAreasDetailed = [
  { name: "Guelph", region: "Wellington County", primary: true },
  { name: "Toronto", region: "Greater Toronto Area", primary: false },
  { name: "Mississauga", region: "Peel Region", primary: false },
  { name: "Kitchener", region: "Waterloo Region", primary: false },
  { name: "Waterloo", region: "Waterloo Region", primary: false },
  { name: "Cambridge", region: "Waterloo Region", primary: false },
  { name: "Hamilton", region: "Hamilton-Wentworth", primary: false },
  { name: "Milton", region: "Halton Region", primary: false },
  { name: "Burlington", region: "Halton Region", primary: false },
  { name: "Oakville", region: "Halton Region", primary: false }
];

export const whyHireUs = {
  title: "Why Hire a Licensed Electrical Contractor?",
  content: "Whether building a new home or business, or renovating an existing one, there are many areas where you can save money. But when it comes to the safety of the people you love or jeopardizing your investment, do you really want to cut costs? Hiring a professional, licensed electrician gives you the confidence of knowing you have a business that stands behind its work and its workers. Janes Electrical Services gives you that peace of mind."
};

export const aboutContent = {
  title: "About Us",
  paragraphs: [
    "Janes Electrical Services is a locally owned and operated electrical contracting company providing reliable, high-quality electrical services for residential and light commercial customers in Guelph, Ontario and the surrounding Greater Golden Horseshoe region.",
    "We specialize in installations, repairs, upgrades, and troubleshooting, with a strong focus on safety, efficiency, and code compliance.",
    "From new construction and remodels to service calls and emergency repairs, we take pride in delivering dependable workmanship and clear communication on every job.",
    "Our goal is simple: to provide honest service, fair pricing, and electrical solutions our customers can trust."
  ]
};

export const heroImage = "https://images.unsplash.com/photo-1682345262055-8f95f3c513ea?w=1200&q=80";

// SEO Keywords for reference
export const seoKeywords = [
  "electrician Guelph",
  "electrical contractor Guelph Ontario",
  "residential electrician Guelph",
  "commercial electrician Toronto",
  "EV charger installation Ontario",
  "pot lights installation Guelph",
  "basement electrical wiring",
  "licensed electrician Mississauga",
  "electrical repairs Kitchener",
  "panel upgrades Waterloo",
  "emergency electrician Cambridge",
  "electrical services Hamilton"
];
